import qs from "qs";
import { useLocation, useParams, useResolvedPath, UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import mapValues from "lodash/mapValues";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import { useContext } from "react";
export function createSearchParams(params) {
    return qs.stringify(params, {
        addQueryPrefix: false,
        allowDots: true
    });
}
export function parseSearchParams(search) {
    return qs.parse(search, {
        ignoreQueryPrefix: true,
        allowDots: true
    });
}
export function useQuery() {
    const { search } = useLocation();
    return parseSearchParams(search);
}
export function parseValues(params) {
    const handleValue = (v) => {
        // Boolean
        if (v.toLowerCase?.() === "false")
            return false;
        if (v.toLowerCase?.() === "true")
            return true;
        // Number
        const num = Number.parseFloat(v);
        if (!Number.isNaN(num) && num.toString() === v)
            return num;
        if (isArray(v))
            return v.map(handleValue);
        if (isObject(v))
            return mapValues(v, handleValue);
        return v;
    };
    return mapValues(params, handleValue);
}
export function useParsedQuery() {
    return parseValues(useQuery());
}
export function useParsedQueryAndParams(props) {
    return {
        ...parseValues({
            ...useQuery(),
            ...useParams()
        }),
        ...props
    };
}
export function useAbsolutePath(to) {
    const { navigator } = useContext(NavigationContext);
    const base = useResolvedPath(to);
    return navigator.createHref(base);
}
//# sourceMappingURL=utils.js.map